export default "__VITE_ASSET__Xi1NV2iA__"